import React from "react";
import styled from "styled-components";
import {
  ShoppingCartOutlined,
  SmileOutlined,
  GiftOutlined,
  CreditCardOutlined,
} from "@ant-design/icons";
import "aos/dist/aos.css";

const NewsletterWrapper = styled.div`
  background: #f8f9fa;
  padding: 60px 20px;

  .container {
    max-width: 1200px;
    margin: 0 auto;
  }

  .features-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 40px;
  }

  .feature-item {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;

    .feature-icon {
      font-size: 48px;
      color: #fd8e07;
      margin-bottom: 20px;
      transition: all 0.3s ease;
    }

    .feature-title {
      font-size: 16px;
      font-weight: 700;
      color: #000;
      margin-bottom: 12px;
      font-family: "Outfit", sans-serif;
    }

    .feature-description {
      font-size: 14px;
      color: #666;
      line-height: 1.6;
      font-family: "Outfit", sans-serif;
    }

    &:hover {
      .feature-icon {
        transform: scale(1.1);
      }
    }
  }

  @media (max-width: 1024px) {
    .features-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 30px;
    }
  }

  @media (max-width: 768px) {
    padding: 40px 20px;

    .features-grid {
      grid-template-columns: 1fr;
      gap: 30px;
    }

    .feature-item {
      .feature-icon {
        font-size: 40px;
      }

      .feature-title {
        font-size: 15px;
      }

      .feature-description {
        font-size: 13px;
      }
    }
  }

  @media (max-width: 576px) {
    padding: 30px 15px;

    .features-grid {
      gap: 25px;
    }

    .feature-item {
      .feature-icon {
        font-size: 36px;
        margin-bottom: 15px;
      }

      .feature-title {
        font-size: 14px;
        margin-bottom: 8px;
      }

      .feature-description {
        font-size: 12px;
      }
    }
  }
`;

const Newsletter = () => {
  const features = [
    {
      icon: <ShoppingCartOutlined />,
      title: "Free Fast Shipping",
      description: "Free shipping on orders $100",
    },
    {
      icon: <SmileOutlined />,
      title: "Our Happy Clients",
      description: "Online service center worldwide",
    },
    {
      icon: <GiftOutlined />,
      title: "Best Special Gifts",
      description: "Return policy available 365 days",
    },
    {
      icon: <CreditCardOutlined />,
      title: "Secure Payments",
      description: "Coupon & offers on first purchase",
    },
  ];

  return (
    <NewsletterWrapper>
      <div className="container">
        <div className="features-grid">
          {features.map((feature, index) => (
            <div
              key={index}
              className="feature-item"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </NewsletterWrapper>
  );
};

export default Newsletter;
